import * as React from "react";
import { Table, Empty } from "antd";
import { TDevicePresentationModel } from "../../../presenter/device/model/DevicePresentationModel";
import ConfirmationModal from "./ConfirmationModal";
import { DeviceTableConstants } from "../../../common/Constants";

const DeviceTable = ({
  devices,
  translate,
  modalVisible,
  hideModal,
  selectedDevice,
  onConfirm,
  columns,
  loading,
  username,
  password,
  onChangeUsername,
  onChangePassword,
  loginButtonDisabled
}: {
  devices: TDevicePresentationModel[];
  translate: any;
  modalVisible: boolean;
  hideModal: any;
  selectedDevice?: TDevicePresentationModel;
  onConfirm: any;
  columns: any[];
  loading: boolean;
  username: string;
  password: string;
  onChangeUsername: any;
  onChangePassword: any;
  loginButtonDisabled: boolean;
}) => {
  return (
    <React.Fragment>
      <div className={"device-table-wrapper"}>
        <ConfirmationModal
          key="confirmation-modal-component"
          onCancel={hideModal}
          translate={translate}
          modalVisible={modalVisible}
          selectedDevice={selectedDevice}
          onConfirm={onConfirm}
          loading={loading}
          username={username}
          password={password}
          onChangeUsername={onChangeUsername}
          onChangePassword={onChangePassword}
          loginButtonDisabled={loginButtonDisabled}
        />
        <Table
          dataSource={devices}
          columns={columns}
          size="small"
          rowKey={record => record.deviceId}
          locale={{
            emptyText: (
              <Empty
                description={translate("device_management_page.no_data")}
              ></Empty>
            )
          }}
          pagination={
            devices.length < DeviceTableConstants.MIN_PAGE_SIZE
              ? false
              : {
                  defaultPageSize: DeviceTableConstants.PAGE_SIZE,
                  showSizeChanger: true,
                  locale: {
                    items_per_page: translate(
                      "device_management_page.items_per_page"
                    )
                  },
                  pageSizeOptions:
                    devices.length < 50
                      ? ["5", "10", "25", "50"]
                      : ["5", "10", "25", "50", devices.length.toString()]
                }
          }
        />
      </div>
    </React.Fragment>
  );
};

export default DeviceTable;
